<template>
  <v-dialog
    v-model="dialog"
    :width="dialogWidth"
    :persistent="false"
    transition="fade-transition"
  >
    <v-form v-model="valid" @submit="save">
      <v-card>
        <v-card-title class="headline">{{
          $t("changeUsernameDialog.title")
        }}</v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-row>
              <v-col>
                <info-block small class="help-text-small">{{noticeText}}</info-block>
              </v-col>
            </v-row>
          </v-container>
          <v-text-field
            data-test-id="name"
            ref="username"
            v-model="name"
            :disabled="loading"
            :rules="nameRules"
            :label="$t('common.nickname')"
            autocomplete="off"
            prepend-icon="mdi-account"
            required
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="submit" class="primary" :loading="loading" :disabled="!valid">
            <v-icon left>mdi-content-save</v-icon>{{ $t("common.save") }}
          </v-btn>
          <v-btn :disabled="loading" class="error" text @click="close()">
            <v-icon left>mdi-close</v-icon>{{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import InfoBlock from "@/widgets/InfoBlock";
import {MUTATION_PROFILE_LOADED} from "@/plugins/store";

export default {
  name: "ChangeUsernameDialog",
  mixins: [],
  components: {
    InfoBlock,
  },
  props: {
    initialUsername: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    confirmAction: {
      type: Function,
      required: false,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      nameRules: [
        v => !!v || this.$t('registration.nickname-required'),
        v =>
          (v && v.length < 100) ||
          this.$t('registration.nickname-max-chars', {n: 100}),
        v =>
          (v && v.indexOf(" ") == -1) ||
          this.$t('registration.nickname-no-spaces')
      ],
      valid: true,
      dialog: false,
      loading: false,
      changeAllowedAt: null,
      name: undefined,
      usernameError: undefined
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    dialogWidth: function () {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "450";
      }
      return "90%";
    },
    noticeText: function() {
      var ret;
      if (this.changeAllowedAt && this.changeAllowedAt.getTime() > new Date().getTime()) {
        let dateStr = this.$datefns.formatRelativeWithTime(this.changeAllowedAt)
        ret = this.$t('changeUsernameDialog.change-allowed-at', {date: dateStr});
      } else {
        ret = this.$t('changeUsernameDialog.max-frequency-info', {hours: 24});
      }
      return ret;
    }
  },
  mounted() {
    this.dialog = this.visible;
    this.name = this.initialUsername;
    this.loadUsernameInfo()
    window.setTimeout(
      function() {
        this.$refs["username"].focus();
      }.bind(this),
      0
    );
  },
  methods: {
    save(e) {
      e.preventDefault()
      this.loading = true;
      this.$api
      .putUsername(this.name)
      .then(response => {
        this.loading = false;
        this.$store.commit(MUTATION_PROFILE_LOADED, response.data);
        this.confirmAction && this.confirmAction();
        this.close();
      })
      .catch(error => {
        this.loading = false;
        this.$common.onError(error)
      });
      return false
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
    loadUsernameInfo() {
      this.$api
        .getUsername()
        .then(response => {
          let usernameInfo = response.data;
          this.changeAllowedAt = usernameInfo.allowChangeAt ? new Date(usernameInfo.allowChangeAt) : null
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style scoped>
</style>